module.exports = __webpack_public_path__ + "static/media/nuit.17879f82.jpg";